import { Key } from "../../../../../models";
import { Command, Command1 } from "../../../../../Command";

export class InitUpsertSensorCommand implements Command1<Key>
{
    constructor(private loadVehiclesCmd: Command, private loadMeasuresCmd: Command, private loadGeotabSensors: Command1<Key>)
    {
    }

    execute = (vehicleId: Key): void => {
        this.loadVehiclesCmd.execute()
        this.loadMeasuresCmd.execute();
        if(vehicleId != null) {
            this.loadGeotabSensors.execute(vehicleId);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Sensor/commands/InitUpsertSensorCommand.ts